import {
  ArrowDownward,
  ArrowForward,
  Clear,
  Close,
  Delete,
  Done,
  History,
  SettingsBackupRestore,
} from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TreeItem, { TreeItemProps } from '@mui/lab/TreeItem';
import TreeView from '@mui/lab/TreeView';
import { Box, Card, Grid, IconButton, MenuItem, Select, Stack, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { FiMoreVertical } from 'react-icons/fi';
import {
  saveCandidateInteractionPipelineResultCommSettings,
  PipelineResultCommSettings,
  getCandidateInteractionPipelineResultCommSettings,
  resetCandidateInteractionPipelineResultCommSettings,
} from 'wisestep-api';
import {
  WsButton,
  Label,
  ControlledTextInput,
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsElementWithPopOver,
  WsSelect,
} from 'wisestep-base';

// import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import { useWorkspaceContext } from '../../../context';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../hooks/useAtsCustomAPIAccess';
import { warning, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { EditIconButton } from '../components/StyledIconButtons';

import AddActionButtonDialog from './AddActionButtonDialog';
import ConfirmationDialog from './ConfirmationDialog';
import { CustomContent } from './CustomTreeComponent';
import { action, buildNewItem, candidateInteractionMessagingPipelines } from './helper';

type Size = {
  fontSize: number;
};
const SmallLabel = styled(Label)(({ fontSize }: Size) => ({
  fontSize: fontSize,
  fontWeight: 'bold',
  backgroundColor: WsColors.White,
  borderRadius: 3,
  border: '1px solid' + WsColors.TheBlues200,
  cursor: 'pointer',
  padding: 4,
}));
const StyledInput = styled(ControlledTextInput)(() => ({
  backgroundColor: WsColors.White,
  borderRadius: 3,
  size: 'small',
  border: '1px solid' + WsColors.TheBlues200,
}));

const ManageRecruiterActionsNew = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [controlThree, setControlThree] = useState(false);

  const CustomTreeItem = (props: TreeItemProps) => (
    <TreeItem ContentComponent={CustomContent} {...props} />
  );
  const [showDialog, setShowDialog] = useState(false);
  const [type, setType] = useState<'reset' | 'clear'>();
  const [nodeID, setNodeID] = useState('');
  const [ediNodeName, setEdiNodeName] = useState(false);
  const [edit, setEdit] = useState('');
  const indexOptions = ['Recruiter response', 'Communication', 'Candidate Response'];
  const [selectedIndex, setSelectedIndex] = useState('Recruiter response');
  const [
    candidateInteractionMessagingPipelinesData,
    setCandidateInteractionMessagingPipelinesData,
  ] = useState<PipelineResultCommSettings>();
  const [
    candidateInteractionMessagingPipelinesDataBackup,
    setCandidateInteractionMessagingPipelinesDataBackup,
  ] = useState<PipelineResultCommSettings>();
  const [pipelineData, setPipelineData] = useState<candidateInteractionMessagingPipelines[]>([]);
  const [idArray, setIdArray] = useState<string[]>([]);
  const methods = useForm();
  const openDialog = (type: 'reset' | 'clear') => {
    setType(type);
    setShowDialog(true);
  };
  const closeDialog = () => setShowDialog(false);
  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_RECRUITER_ACTIONS,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];

  useEffect(() => {
    (async function () {
      const candidateInteractionMessagingPipelinesDataReq =
        await getCandidateInteractionPipelineResultCommSettings();
      if (candidateInteractionMessagingPipelinesDataReq.data) {
        setCandidateInteractionMessagingPipelinesData(
          candidateInteractionMessagingPipelinesDataReq.data
        );

        setCandidateInteractionMessagingPipelinesDataBackup(
          candidateInteractionMessagingPipelinesDataReq.data
        );
      }
    })();
  }, []);

  useEffect(() => {
    if (candidateInteractionMessagingPipelinesData) {
      let data: candidateInteractionMessagingPipelines[] =
        candidateInteractionMessagingPipelinesData.pipelineData;
      if (selectedIndex === 'Recruiter Actions') {
        data = candidateInteractionMessagingPipelinesData.pipelineData;
      } else if (selectedIndex === 'Communication') {
        data = candidateInteractionMessagingPipelinesData.communicationData;
      } else if (selectedIndex === 'Candidate Response') {
        data = candidateInteractionMessagingPipelinesData.resultData;
      }
      setPipelineData(data);
    }
  }, [candidateInteractionMessagingPipelinesData, selectedIndex]);
  const [arr, setArr] = useState<candidateInteractionMessagingPipelines[]>([]);
  const [condition1, setCondition1] = useState('');
  const getType = () => {
    if (selectedIndex === 'Recruiter Actions') {
      return 'pipeline';
    } else if (selectedIndex === 'Communication') {
      return 'communication';
    } else if (selectedIndex === 'Candidate Response') {
      return 'result';
    }
  };
  const allActionsHandler = (
    array: candidateInteractionMessagingPipelines[],
    id: string,
    value: string,
    type: string
  ) => {
    const temp: candidateInteractionMessagingPipelines[] = array;
    temp.forEach((child, index) => {
      if (!isEmpty(child.nodes)) {
        allActionsHandler(child.nodes, id, value, type);
      }

      if (child.id === id) {
        arr?.forEach((c) => (c.condition = condition1));
        const handler = {
          ['editName']: () => {
            child.name = value;
          },
          ['addNewChild']: () => {
            child.nodes.push(
              buildNewItem(
                `${temp[index].name}-${temp.length}`
              ) as candidateInteractionMessagingPipelines
            );
          },
          ['addNewSibling']: () => {
            temp.splice(
              index + 1,
              0,
              buildNewItem(
                `${temp[index].name}-${temp.length}`
              ) as candidateInteractionMessagingPipelines
            );
          },
          ['delete']: () => {
            temp.splice(index, 1);
          },
          ['deleteAction']: () => {
            temp[index].action = {};
          },
          ['addAction']: () => {
            temp[index].action = JSON.parse(value) as action;
          },
          ['addCondition']: () => {
            setArr(temp);
            temp[index].condition = value;
          },
          ['addColor']: () => {
            temp[index].color = value;
          },
        };
        handler[type]();
        setPipelineData([...pipelineData]);
      }
    });
  };
  const addToTop = () => {
    pipelineData.unshift(
      buildNewItem(`New-${pipelineData.length}`) as candidateInteractionMessagingPipelines
    );
    setPipelineData([...pipelineData]);
  };

  const getTreeItemsFromData = (treeItems: candidateInteractionMessagingPipelines[]) => {
    return treeItems.map((treeItemData) => {
      // let children;
      // if (treeItemData.nodes && treeItemData.nodes.length > 0) {
      //   children = getTreeItemsFromData(treeItemData.nodes);
      // }
      return (
        <CustomTreeItem
          key={treeItemData.id}
          nodeId={treeItemData.id}
          label={
            <>
              <Grid container p={1} item xs={12}>
                <Grid item xs={11} container display="flex" flexDirection="row">
                  <Grid item xs={10} container display="flex" flexDirection="row">
                    {ediNodeName && treeItemData.id === edit ? (
                      <Box display="flex" flexDirection="row">
                        <Box width="7vw" height="3vh" pr={2}>
                          <WsSelect
                            name="name"
                            defaultValue={treeItemData.condition ?? 'and'}
                            selectArray={[
                              {
                                label: 'AND',
                                value: 'and',
                              },
                              {
                                label: 'OR',
                                value: 'or',
                              },
                            ]}
                            size="small"
                            onChangeValue={(m) => {
                              setCondition1(m);
                              allActionsHandler(pipelineData, treeItemData.id, m, 'addCondition');
                            }}
                          />
                        </Box>
                        <StyledInput name="editStageName" defaultValue={treeItemData.name} />
                        <Box maxHeight={40} ml={2}>
                          <Select
                            sx={{ maxHeight: 40, minWidth: 180 }}
                            value={treeItemData.color ?? '#00B4D8'}
                            onChange={(m) =>
                              allActionsHandler(
                                pipelineData,
                                treeItemData.id,
                                m.target.value,
                                'addColor'
                              )
                            }
                            size="small"
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            <MenuItem value="#00B4D8" sx={{ minWidth: 200 }}>
                              <Grid container alignItems="center" gap={1}>
                                <Box
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    bgcolor: '#00B4D8',
                                  }}
                                />
                                <Typography variant="body1">Default</Typography>
                              </Grid>
                            </MenuItem>
                            <MenuItem value="#00BBA4" sx={{ minWidth: 200 }}>
                              <Grid container alignItems="center" gap={1}>
                                <Box
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    bgcolor: '#00BBA4',
                                  }}
                                />
                                <Typography variant="body1">Positive Action</Typography>
                              </Grid>
                            </MenuItem>
                            <MenuItem value="#E9B327" sx={{ minWidth: 200 }}>
                              <Grid container alignItems="center" gap={1}>
                                <Box
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    bgcolor: '#E9B327',
                                  }}
                                />
                                <Typography variant="body1">Neutral Action</Typography>
                              </Grid>
                            </MenuItem>
                            <MenuItem value="#FF2E49" sx={{ minWidth: 200 }}>
                              <Grid container alignItems="center" gap={1}>
                                <Box
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    bgcolor: '#FF2E49',
                                  }}
                                />
                                <Typography variant="body1">Negative Action</Typography>
                              </Grid>
                            </MenuItem>
                          </Select>
                        </Box>
                      </Box>
                    ) : (
                      <Box display="flex" flexDirection="row" gap={1}>
                        <SmallLabel fontSize={15}>
                          {treeItemData.condition?.toLocaleUpperCase() ?? 'AND'}
                        </SmallLabel>

                        <SmallLabel fontSize={15}>{treeItemData.name}</SmallLabel>
                        <Box
                          sx={{
                            ml: 2,
                            mt: 1.5,
                            bgcolor: treeItemData?.color ?? WsColors.TheBlues500,
                            pl: 2,
                            width: 18,
                            height: 18,
                          }}
                        />
                      </Box>
                    )}

                    <Grid item>
                      {ediNodeName && treeItemData.id === edit ? (
                        <Grid display="flex" gap={1} mx={1}>
                          <IconButton
                            onClick={() => setEdiNodeName(false)}
                            sx={{
                              borderRadius: 1.5,
                              border: '1px solid #00B4D8',

                              width: 40,
                              height: 40,
                            }}
                          >
                            <Close />
                          </IconButton>
                          <IconButton
                            onClick={methods.handleSubmit((data: FieldValues) => {
                              allActionsHandler(
                                pipelineData,
                                treeItemData.id,
                                data.editStageName ?? treeItemData.name,
                                'editName'
                              );
                              setEdiNodeName(false);
                              setEdit('');
                              methods.reset();
                            })}
                            sx={{
                              borderRadius: 1.5,
                              backgroundColor: '#00B4D8',
                              width: 40,
                              height: 40,
                              '&:hover': {
                                backgroundColor: '#00B4D8',
                                border: '1px solid #00B4D8',
                              },
                            }}
                          >
                            <Done sx={{ color: WsColors.White }} />
                          </IconButton>
                        </Grid>
                      ) : (
                        <EditIconButton
                          onClick={() => {
                            if (manageAccess) {
                              setEdit(treeItemData.id);
                              setEdiNodeName(true);
                            } else {
                              setNotification(
                                warning('You do not have enough permissions to perform this action')
                              );
                              return;
                            }
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={2} mt={0.5} display="flex" justifyContent="flex-end">
                    {!isEmpty(treeItemData.action) && (
                      <WsButton
                        variant="text"
                        endIcon={<Clear />}
                        onClick={() => {
                          if (manageAccess) {
                            allActionsHandler(pipelineData, treeItemData.id, '', 'deleteAction');
                          } else {
                            setNotification(
                              warning('You do not have enough permissions to perform this action')
                            );
                            return;
                          }
                        }}
                      >
                        {treeItemData.action?.name ?? ''}
                      </WsButton>
                    )}
                  </Grid>
                </Grid>
                <Grid p={1} item xs={1} container>
                  <WsElementWithPopOver
                    element={<FiMoreVertical color={WsColors.GenericRichBlack} />}
                  >
                    <Stack p={1} columnGap={1} alignItems="flex-start">
                      <WsButton
                        startIcon={<ArrowForward />}
                        onClick={() =>
                          allActionsHandler(pipelineData, treeItemData.id, '', 'addNewSibling')
                        }
                        variant="text"
                        size="small"
                      >
                        Add Sibling
                      </WsButton>

                      <WsButton
                        onClick={() =>
                          allActionsHandler(pipelineData, treeItemData.id, '', 'addNewChild')
                        }
                        startIcon={<ArrowDownward />}
                        variant="text"
                        size="small"
                      >
                        Add Child
                      </WsButton>
                      <WsButton
                        onClick={() => {
                          setNodeID(treeItemData.id);
                          setControlThree(true);
                        }}
                        startIcon={<AddIcon />}
                        variant="text"
                        size="small"
                      >
                        Action
                      </WsButton>
                      <WsButton
                        startIcon={<Delete />}
                        onClick={() =>
                          allActionsHandler(pipelineData, treeItemData.id, '', 'delete')
                        }
                        variant="text"
                        size="small"
                      >
                        Remove
                      </WsButton>
                    </Stack>
                  </WsElementWithPopOver>
                </Grid>
              </Grid>
            </>
          }
        >
          {treeItemData.nodes &&
            treeItemData.nodes.length > 0 &&
            getTreeItemsFromData(treeItemData.nodes ?? [])}
        </CustomTreeItem>
      );
    });
  };

  const handler = async (type: 'reset' | 'clear') => {
    if (
      candidateInteractionMessagingPipelinesData &&
      candidateInteractionMessagingPipelinesDataBackup
    ) {
      if (type === 'clear') {
        setCandidateInteractionMessagingPipelinesData({
          ...candidateInteractionMessagingPipelinesDataBackup,
        });
        setShowDialog(false);
      } else {
        try {
          const resetData = await resetCandidateInteractionPipelineResultCommSettings(
            getType() ?? 'pipeline'
          );
          if (resetData.data) setCandidateInteractionMessagingPipelinesData(resetData.data);
          setShowDialog(false);
        } catch (error) {
          setNotification(warning('Something Went Wrong , Please try again'));
        }
      }
    }
  };

  const saveToApi = async () => {
    console.log('++++++', pipelineData);

    if (candidateInteractionMessagingPipelinesData && pipelineData) {
      const payload: PipelineResultCommSettings = candidateInteractionMessagingPipelinesData;
      if (selectedIndex === 'Recruiter Actions') {
        payload.pipelineData = pipelineData;
      } else if (selectedIndex === 'Communication') {
        payload.communicationData = pipelineData;
      } else if (selectedIndex === 'Candidate Response') {
        payload.resultData = pipelineData;
      }
      try {
        await saveCandidateInteractionPipelineResultCommSettings(payload);
        setNotification(success('Settings updated successfully'));
      } catch (error) {
        setNotification(warning('Something Went Wrong , Please try again'));
      }
    }
  };
  return (
    <Grid>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.CRM,
          Pages['MANAGE_RECRUITER_ACTIONS']
        )}
      />
      <Grid item container display="flex" p={1} flexDirection="row">
        <Card
          sx={{
            minHeight: '83vh',
            width: '24%',
            p: 3,
            background: WsColors.TheBlues900,
            borderRadius: 2,
            mr: '10px',
            cursor: 'pointer',
          }}
        >
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.WHITE} bold={true}>
            Manage Actions
          </WsTypography>
          {indexOptions.map((i, index) => (
            <Box
              key={index}
              sx={{
                background: selectedIndex === i ? WsColors.White : null,
                m: 1,
                mt: 2,
                borderRadius: 2,
                p: 1,
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <WsTypography
                variant={WsTypoVariants.TITLE}
                color={selectedIndex === i ? WsTypoColors.PRIMARY : WsTypoColors.WHITE}
                onClick={() => setSelectedIndex(i)}
                cursor="pointer"
              >
                {i}
              </WsTypography>
            </Box>
          ))}
        </Card>
        <Card sx={{ minHeight: '83vh', width: '75%', p: '1', borderRadius: 2 }}>
          <Grid margin={2}>
            <Grid display="flex" flexDirection="row" item p={2} justifyContent="space-between">
              <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
                {selectedIndex}
              </WsTypography>
              <Grid gap={1} item container justifyContent="flex-end" xs={6}>
                <WsButton size="small" onClick={() => addToTop()} variant="contained">
                  Add New Item
                </WsButton>
                <WsButton variant="contained" size="small" onClick={() => saveToApi()}>
                  Save changes
                </WsButton>

                <Box p={1}>
                  <WsElementWithPopOver
                    element={<FiMoreVertical color={WsColors.GenericRichBlack} />}
                  >
                    <Stack p={1} columnGap={1} alignItems="flex-start">
                      <WsButton
                        variant="text"
                        onClick={() => openDialog('clear')}
                        startIcon={<History />}
                      >
                        Reset changes
                      </WsButton>
                      <WsButton
                        variant="text"
                        onClick={() => openDialog('reset')}
                        startIcon={<SettingsBackupRestore />}
                      >
                        Reset to default
                      </WsButton>
                    </Stack>
                  </WsElementWithPopOver>
                </Box>
              </Grid>
            </Grid>

            <FormProvider {...methods}>
              <Grid margin={2}>
                <TreeView
                  expanded={idArray}
                  defaultExpandIcon={<ChevronRightIcon />}
                  defaultCollapseIcon={<ExpandMoreIcon />}
                  onNodeToggle={(_, nodeIds: string[]) => {
                    setIdArray(nodeIds);
                  }}
                >
                  {getTreeItemsFromData(pipelineData ?? [])}
                </TreeView>
              </Grid>
            </FormProvider>
            <AddActionButtonDialog
              openDialog={controlThree}
              closeDialog={() => setControlThree(false)}
              onChangeHandler={(data: action) =>
                allActionsHandler(pipelineData, nodeID, data as string, 'addAction')
              }
            />
            <ConfirmationDialog
              openDialog={showDialog}
              closeDialog={() => closeDialog()}
              handler={(type) => handler(type)}
              variant={type ?? 'clear'}
            />
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};
export default ManageRecruiterActionsNew;
